module.exports = __webpack_public_path__ + "static/assembly-multi-part-chamber-9d71dfbe217cdf36b3ff6901e879a5bf.gif";